import { PersistentStorageStrategyFactory } from './factories';
import { sessionStorageStrategy } from './strategies';
var resolver = new PersistentStorageStrategyFactory();
resolver.register(sessionStorageStrategy);
export var sessionStorage = resolver.getStrategy().storageInstance();
